import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";

export default {
  name: "consentdocumentupload",
  components: { customModal },

  props: {
    documentTitle: { type: String, default: "" },
    description: { type: String, default: "" },
    docid: { type: String, default: "" },
    siteCode: { type: String, default: "" },
    protocolNumber: { type: String, default: "" }, 
    versionNumber: { type: String, default: "" }, 
  },

  data() {
    return {
      documentEdit: false,
      documentLoader: false,
      docTitle: "",
      docVersion: "",
      formName: "",
      language: "",
      status: "Active",
      siteid: "",
      list: [],
       countries: [],
    languageOptions: [],
      azuredata: { Document: [] },
      loadingDocUpload: false,
      documentUploadFields: {
        effectiveDate: "",
        expiryDate: "",
        description: "",
        changesHistory: "",
       
        irbApprovalDate: "",
        irbApprovalNumber: ""
      },
    documentValidationsError: {
  version: false,
  //effectiveDate: false,
  expiryDate: false,
  //irbApprovalDate: false,
  file: false
},
      baseurl: process.env.VUE_APP_Service_URL,
      currentUser: "",
    };
  },

  mounted() {
    this.initializeWithProps();
    this.getCountries();
  },

  methods: {
    async getCountries() {
  try {
    const idtoken = store.getters.getIdToken;

    const res = await axios.get(
      `${this.baseurl}/management/country/getcountrieswithlanguage`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    this.countries = res.data;
    this.languageOptions = [
      ...new Map(
        res.data.map((item) => [
          item.language,
          {
            language: item.language,
            code: item.isO_639_1_LangCode,
          },
        ])
      ).values(),
    ];

    this.languageOptions.sort((a, b) =>
      a.language.localeCompare(b.language)
    );

  } catch (error) {
    console.error("Error fetching languages:", error);
  }
},
    initializeWithProps() {

      if (this.versionNumber) {
        this.docVersion = this.versionNumber;
      }
      if (this.protocolNumber) {
      }
    },

    handleClose() {
      this.$emit("uploadlibactive");
      this.resetLocal();
    },

    resetLocal() {
    this.documentUploadFields = {
  effectiveDate: "",
  expiryDate: "",
  description: "",
  changesHistory: "",
  irbApprovalDate: "",
  irbApprovalNumber: ""
};
      this.docTitle = "";
      this.docVersion = "";
      this.formName = "";
      this.language = "";
      this.status = "Active";
      this.azuredata.Document = [];
      this.list = [];
     this.documentValidationsError = {
  version: false,
 // effectiveDate: false,
  expiryDate: false,
  //irbApprovalDate: false,
  file: false
};
      this.loadingDocUpload = false;
      this.documentLoader = false;
    },

    async getsiteid() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/site/getall?studyId=${studyId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const found = res.data.find(
            (element) => element.siteCode == this.siteCode
          );
          if (found) {
            this.siteid = found.siteID;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    browse() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },

    previewFiles(e) {
      this.azuredata.Document = [];
      this.azuredata.Document.push(e.target.files);
      this.list = [...this.list, ...this.azuredata.Document[0]];
    },

    removefile(idx) {
      this.list.splice(idx, 1);
    },

async validatedocument() {
  this.documentValidationsError = {
    version: false,
    //effectiveDate: false,
    expiryDate: false,
    // irbApprovalDate: false,
    file: false
  };

  let isValid = true;

  if (!this.docVersion.trim()) {
    this.documentValidationsError.version = true;
    isValid = false;
  }

  if (this.list.length === 0) {
    this.documentValidationsError.file = true;
    isValid = false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // if (this.documentUploadFields.effectiveDate) {
  //   const effective = new Date(this.documentUploadFields.effectiveDate);
  //   effective.setHours(0, 0, 0, 0);

  //   if (effective < today) {
  //     this.documentValidationsError.effectiveDate = true;
  //     isValid = false;
  //   }
  // }

  if (this.documentUploadFields.expiryDate) {
    const expiry = new Date(this.documentUploadFields.expiryDate);
    expiry.setHours(0, 0, 0, 0);

    if (expiry < today) {
      this.documentValidationsError.expiryDate = true;
      isValid = false;
    }
  }

  // if (this.documentUploadFields.irbApprovalDate) {
  //   const irbApprovalDate = new Date(this.documentUploadFields.irbApprovalDate);
  //   irbApprovalDate.setHours(0, 0, 0, 0);

  //   if (irbApprovalDate < today) {
  //     this.documentValidationsError.irbApprovalDate = true;
  //     isValid = false;
  //   }
  // }

  return isValid;
} ,
 
async submitFile() {
  this.loadingDocUpload = true;
  const isValid = await this.validatedocument();

  if (!isValid) {
    this.loadingDocUpload = false;
    return;
  }

  await this.getsiteid();

  try {
    const idtoken = store.getters.getIdToken;
    let vervalue = this.docVersion.toString();

    const uploadPromises = this.list.map(async (eachfiles) => {
      const formData = new FormData();

      formData.append("DocumentDescription", this.documentUploadFields.description);
      formData.append("StudyId", store.getters.getStudyIs);
      formData.append("ProtocolNumber", this.protocolNumber);
      formData.append("SiteId", this.siteid);
      formData.append("File", eachfiles);
      formData.append("Language", this.language || "");
      formData.append("EffectiveDate", this.documentUploadFields.effectiveDate);
      formData.append("ExpiryDate", this.documentUploadFields.expiryDate || "");
      formData.append("Version", vervalue.trim());
      formData.append("DocumentTitle", this.docTitle || eachfiles.name);
      formData.append("VersionMessage", this.documentUploadFields.changesHistory);
      formData.append("IrbApprovalDate", this.documentUploadFields.irbApprovalDate || "");
      formData.append("IrbApprovalNumber", this.documentUploadFields.irbApprovalNumber || "");

      return axios.post(`${this.baseurl}/management/patientdocument/uploadconsentdocument`, formData, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "multipart/form-data",
        },
      });
    });

    await Promise.all(uploadPromises);

    alert("Documents saved successfully");

    this.$emit("uploadlibactive");
    this.$emit("documentUploaded");

    this.resetLocal();

 } catch (err) {
  let errorMsg = "Upload failed";

  if (err.response && err.response.data) {
    const data = err.response.data;

    if (Array.isArray(data.messages) && data.messages.length > 0) {
      // Extract only the readable part
      const rawMsg = data.messages[0];
      const match = rawMsg.match(/Parent folder.*StudyId/);

      if (match) {
        errorMsg = "eTMF " + match[0];
      } else {
        errorMsg = rawMsg;
      }
    } else if (data.detail) {
      errorMsg = data.detail;
    }
  } else if (err.message) {
    errorMsg = err.message;
  }

  alert(errorMsg);
}
 finally {
    this.loadingDocUpload = false;
  }
},

  },
};